import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { ExitType } from "../../constants/common"

/// "Steps" in the user setup flow. These are the steps as marked by the 
/// custom stepper, though in reality multiple pages may map to a single step.
export enum UserSetupStep {
    VerifyAddress = 0,
    PersonalInfo,
    AdditionalTaxInfo,
    Review,
}

/// "Sub steps" are the actual pages in the user setup flow.
export enum UserSetupSubstep {
  WelcomeBack = 0,
  VerifyAddress,
  PersonalInfo,
  SpouseInfo,
  AdditionalTaxInfo,
  Review,
}

/// Mapping from actual route to CustomStepper step in the UserSetup flow.
export const userSetupRouteMap = {
  '/user/welcome-back': UserSetupStep.VerifyAddress,
  '/user/update-address': UserSetupStep.VerifyAddress,
  '/user/personal-info': UserSetupStep.PersonalInfo,
  '/user/spouse-info': UserSetupStep.PersonalInfo,
  '/user/additional-info': UserSetupStep.AdditionalTaxInfo,
  '/user/review': UserSetupStep.Review,
} as { [key: string]: UserSetupStep };

export const userSetupRoutes = Object.keys(userSetupRouteMap) as string[];

export interface UserSetupState {
    infoAccurate: boolean;
    stepErrors: UserSetupSubstep[];
    exitMessageType: ExitType;
    disableNext: boolean;
    reviewSuccessMode: boolean;
    pInfoSsnValidationError: string;
    pInfoPhoneNoValidationError: string;
    spouseSsnValidationError: string;
}

const initialState: UserSetupState = {
    infoAccurate: true,
    stepErrors: [],
    exitMessageType: ExitType.None,
    disableNext: false,
    reviewSuccessMode: false,
    pInfoSsnValidationError: "",
    pInfoPhoneNoValidationError: "",
    spouseSsnValidationError: "",
} 

export const userSetupSlice = createSlice({
    name: "userSetup",
    initialState,
    reducers: {
      update: (state, action) => {
        state = action.payload;
      },

      addSubstepError: (state, action: PayloadAction<UserSetupSubstep>) => {
        if (!state.stepErrors.includes(action.payload)) {
          state.stepErrors.push(action.payload);
        }
      },
      clearSubstepErrors: (state, action: PayloadAction<UserSetupSubstep>) => {
        state.stepErrors = state.stepErrors.filter((step) => step !== action.payload);
      },
      setInfoAccurate: (state, action) => {
        state.infoAccurate = action.payload;
      },
      setExitMessageType: (state, action) => {
        state.exitMessageType = action.payload;
      },
      setDisableNext: (state, action) => {
        state.disableNext = action.payload;
      },
      setReviewSuccessMode: (state, action) => {
        state.reviewSuccessMode = action.payload;
      },
      setPInfoSsnValidationError: (state, action) => {
        state.pInfoSsnValidationError = action.payload;
      },
      setPInfoPhoneNoValidationError: (state, action) => {
        state.pInfoPhoneNoValidationError = action.payload;
      },
      setSpouseSsnValidationError: (state, action) => {
        state.spouseSsnValidationError = action.payload;
      },
      validateSSN(state, _action: PayloadAction<string>) {
        state.disableNext = true;
      },
      confirmStep: (_) => {},
      confirmAddress: (_) => {},
      verifyAddress: (_) => {},
      verifyPersonalInfo: (_) => {},
      verifySpouseInfo: (_) => {},
      verifyAdditionalTaxInfo: (_) => {},
    },
  });
